export default class MissingOptionValueError extends Error {
};
